export default __webpack_public_path__ + "static/media/doc1.66af0220.jpg";